export class HtmlScrubber {
    scrub = (html: string): string => {
        while (html.endsWith('<p><br></p>')){
            html = html.substring(0, html.length - 11);
        }
        return html;
    };
}
